import { Monitor } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Full-viewport overlay shown on narrow screens for canvas-heavy tools (ImageStudio, the
// Workflow-Builder) that are not touch/mobile-friendly - Konva/Rete node-editor interaction is
// fundamentally a mouse+keyboard interaction model. Making these responsive is a separate,
// larger effort (see TASKS.md Task #94, "separate mobile apps"); Phase 1 (Task #77) only adds
// this honest "please switch devices" notice instead of a broken/unusable canvas.
// `tool` is a key suffix under common:desktopOnly.* (e.g. "imageEditor"), so the component stays
// self-contained and never mixes languages (i18n, Task #76).
export const DesktopOnlyNotice = ({ tool }: { tool: string }) => {
    const { t } = useTranslation('common');
    return (
        <div
            className="d-flex flex-column align-items-center justify-content-center text-center p-4"
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 2000,
                background: 'var(--bs-body-bg)',
            }}
        >
            <Monitor size={40} strokeWidth={1.5} className="text-secondary mb-3" />
            <h5 className="mb-2">{t('desktopOnly.title', { tool: t(`desktopOnly.${tool}`) })}</h5>
            <p className="text-secondary mb-0" style={{ maxWidth: 320 }}>
                {t('desktopOnly.body')}
            </p>
        </div>
    );
};
